<template>
    <div v-if="!loading">
        <div v-if="pictureslist.length">
            <b-row>
                <b-col v-for="(item, index) in pictureslist" :key="index" cols="6" xl="2" lg="2" md="3" sm="4">
                    <div style="box-shadow: 0 4px 24px 0 rgba(34, 41, 47, 0.1);" class="mb-2 rounded border">
                        <div class="text-center p-1 text-truncate">
                            {{ item.storeName }}
                        </div>
                        <div class="rounded w-100" style="height: 150px;">
                            <img :src="BASE_URL_File + item.path" class="w-100 h-100 rounded">
                        </div>
                        <div class="d-flex">
                            <b-button @click="imageRequestsChangeStatus(item.id, true)" variant="flat-primary"
                                class="w-50">
                                <feather-icon icon="CheckIcon" size="18" />
                            </b-button>
                            <b-button @click="imageRequestsChangeStatus(item.id, false)" variant="flat-secondary"
                                class="w-50">
                                <feather-icon icon="XIcon" size="18" />
                            </b-button>
                        </div>
                    </div>
                </b-col>
            </b-row>
        </div>
        <div v-else class="text-center">
            موردی وجود ندارد
        </div>
    </div>
</template>

<script>
import { BCard, BCardText, BLink, BRow, BCol, BButton, BImg, BAvatar, BTable, BPagination, BFormInput } from 'bootstrap-vue';
import { adminService } from '@core/services';

export default {
    components: {
        BCard,
        BCardText,
        BLink,
        BRow,
        BCol,
        BButton,
        BImg,
        BAvatar,
        BTable,
        BPagination,
        BFormInput
    },
    data() {
        return {
            loading: true,
            BASE_URL_File: process.env.VUE_APP_BASE_URL_File,
            pictureslist: [],
            parameters: {
                pageIndex: 1,
                pageSize: 99,
                totalCount: null
            },
        }
    },
    methods: {
        async getImageRequests() {
            this.loading = true
            adminService.imageRequests(this.parameters).then(({ data }) => {
                this.parameters.totalCount = data.totalCount
                this.pictureslist = data.items
                this.loading = false
            })
        },
        imageRequestsChangeStatus(id, accept) {
            let data = {
                id: id,
                accept: accept,
            }
            adminService.imageRequestsChangeStatus(data).then(({ data }) => {
                this.pictureslist = this.pictureslist.filter(value => value.id !== id);
                this.$notif({ type: 'success' });
            })
        },

    },
    mounted() {
        this.getImageRequests()
    },
};
</script>

<style>
.text-truncate {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
</style>